import { Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { useCompanyConfigContext } from "@/context/CompanyConfigContext";
import MarkdownRenderer from "@/components/MarkdownRenderer";

export const Terms = () => {
  const { settings } = useCompanyConfigContext();

  return (
    <Box sx={{ p: 3 }}>
      <Button
        component={Link}
        to="/shop/checkout"
        variant="outlined"
        sx={{ mb: 2 }}
      >
        Back to Cart
      </Button>
      <Typography variant="h3" sx={{ mb: 3 }}>
        Terms and Conditions
      </Typography>
      <Typography>
        <MarkdownRenderer>{settings.strings.terms || ""}</MarkdownRenderer>
      </Typography>
      <Button
        component={Link}
        to="/shop/checkout"
        variant="outlined"
        sx={{ mt: 3 }}
      >
        Back to Cart
      </Button>
    </Box>
  );
};
